"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMissingShiftReportDto = instanceOfMissingShiftReportDto;
exports.MissingShiftReportDtoFromJSON = MissingShiftReportDtoFromJSON;
exports.MissingShiftReportDtoFromJSONTyped = MissingShiftReportDtoFromJSONTyped;
exports.MissingShiftReportDtoToJSON = MissingShiftReportDtoToJSON;
exports.MissingShiftReportDtoToJSONTyped = MissingShiftReportDtoToJSONTyped;
const ShiftType_1 = require("./ShiftType");
/**
 * Check if a given object implements the MissingShiftReportDto interface.
 */
function instanceOfMissingShiftReportDto(value) {
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('payPeriodStart' in value) || value['payPeriodStart'] === undefined)
        return false;
    if (!('payPeriodEnd' in value) || value['payPeriodEnd'] === undefined)
        return false;
    return true;
}
function MissingShiftReportDtoFromJSON(json) {
    return MissingShiftReportDtoFromJSONTyped(json, false);
}
function MissingShiftReportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'facilityId': json['facilityId'] == null ? undefined : json['facilityId'],
        'shiftType': json['shiftType'] == null ? undefined : (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'shiftDate': json['shiftDate'] == null ? undefined : json['shiftDate'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'description': json['description'],
        'payPeriodStart': json['payPeriodStart'],
        'payPeriodEnd': json['payPeriodEnd'],
    };
}
function MissingShiftReportDtoToJSON(json) {
    return MissingShiftReportDtoToJSONTyped(json, false);
}
function MissingShiftReportDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'facilityId': value['facilityId'],
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'specialtyCode': value['specialtyCode'],
        'shiftDate': value['shiftDate'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'description': value['description'],
        'payPeriodStart': value['payPeriodStart'],
        'payPeriodEnd': value['payPeriodEnd'],
    };
}
//# sourceMappingURL=MissingShiftReportDto.js.map